
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const processInclude = require('base/util');
const categoryPills = require('onestic-base/components/categoryPills');
const bannerVideo = require('onestic-base/components/bannerVideo');
const quickShopping = require('./components/quickShopping').assignQuickShopping;

let categoryDatalayer;
let initialDatalayer;

if (window.dataLayer) {
    if (window.datalayerVersion === 'universal') {
        categoryDatalayer = require('plugin-seo/universalDataLayer/layers/category');
    } else {
        categoryDatalayer = require('plugin-seo/dataLayerGA4/layers/category');
        initialDatalayer = require('plugin-seo/dataLayerGA4/layers/globalData');
    }
} else {
    const globalDataCode = require('plugin-seo/dataLayerGA4/layers/globalData');
    window.dataLayer = [];
    globalDataCode.sentInitConsent();
    globalDataCode.collectConsentTrackingInfo();
}

$(document).ready(() => {
    processInclude(categoryPills);
    processInclude(bannerVideo);
    processInclude(quickShopping);

    if (window.dataLayer) {
        processInclude(initialDatalayer);
        processInclude(categoryDatalayer);
    }
});
